import React from "react";
import { Outlet } from "react-router-dom";

import StudentSidebar from "../../components/StudentSidebar/StudentSidebar";
import { StudentScrollableMain, StudentViewportApp } from "./StudentLayout.styles";

const StudentLayout: React.FC = () => (
  <StudentViewportApp>
    <StudentSidebar />
    <StudentScrollableMain>
      <Outlet />
    </StudentScrollableMain>
  </StudentViewportApp>
);

export default StudentLayout;
